let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lUL6U")).then(() => parcelRequire('faw0e'));